"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appStoreMetadata = exports.appStoreMetadataResultSchema = exports.appStoreMetadataOutputSchema = exports.appStoreMetadataArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.appStoreMetadataArgsSchema = zod_1.z.object({
    searchTerms: zod_1.z
        .string()
        .min(1, 'searchTerms is required')
        .max(4096, 'searchTerms must be less than 4096 characters'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the results in.'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
});
// Result schema
exports.appStoreMetadataOutputSchema = zod_1.z.object({
    bundleId: zod_1.z.string(),
    sellerName: zod_1.z.string(),
    primaryGenreName: zod_1.z.string(),
    averageUserRating: zod_1.z.number(),
    userRatingCount: zod_1.z.number(),
    version: zod_1.z.string(),
    description: zod_1.z.string(),
    logo: zod_1.z.string(),
    screenshotUrls: zod_1.z.array(zod_1.z.string()),
    trackId: zod_1.z.number(),
});
exports.appStoreMetadataResultSchema = zod_1.z.union([
    exports.appStoreMetadataOutputSchema,
    exports.appStoreMetadataOutputSchema.nullable(),
]);
exports.appStoreMetadata = (0, common_1.createEmitModeToolMetadata)({
    id: 'appStoreMetadata',
    displayName: 'App Store Metadata',
    displayDescription: 'Fetch Apple App Store metadata for an app by search terms.',
    category: 'search',
    color: common_1.BRAND_COLORS.WEB,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.WEB),
    icon: 'search',
    argsSchema: exports.appStoreMetadataArgsSchema,
}, {
    dependencies: ['options.failIfEmpty'],
    variants: [
        {
            when: { 'options.failIfEmpty': true },
            schema: exports.appStoreMetadataOutputSchema,
        },
        {
            when: { 'options.failIfEmpty': false },
            schema: exports.appStoreMetadataOutputSchema.nullable(),
        },
    ],
    defaultSchema: exports.appStoreMetadataOutputSchema,
});
